import {
    ICadastrarAcaoEtapaBody,
    IDadosReguaEtapa,
    IEtapaAcaoAgendamento,
    IOrdenacaoReguaEtapa,
    IRegua,
    IReguaEtapa,
    IReguaEtapaAcaoFiltro,
} from "../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import {
    AtualizarEtapaReguaService,
    AtualizarReguaServices,
    CadastrarAcaoEtapaService,
    CadastrarEtapaReguaService,
    CadastrarFiltroAcaoEtapaService,
    CadastrarOrdenacaoEtapaServices,
    CadastrarReguaServices,
    CadatrarAgendaAcaoEtapaReguaServices,
    DeletarAcaoReguaService,
    DeletarAgendaAcaoEtapaReguaServices,
    DeletarEtapaReguaService,
    DeletarOrdenacaoEtapaServices,
    DeletarReguaServices,
    DeletearFiltroAcaoEtapaService,
    DesvalidarReguaServices,
    EditarAcaoEtapaService,
    EditarFiltroAcaoEtapaService,
    ExecutarReguaServices,
    GetAcaoReguaService,
    GetAgendaAcaoEtapaReguaServices,
    GetReguaEtapaService,
    GetReguaService,
    ListarAcoesReguaPorEtapaService,
    ListarDadosAcoesEtapaBaixarExcelService,
    ListarDadosAcoesEtapaServices,
    ListarFiltrosAcaoEtapaService,
    ListarOrdenacaoEtapaService,
    ListarReguaEtapaService,
    ListarReguaService,
    ListarServicosSMSService,
    ListarTipoFiltroAcaoEtapaService,
    ListarTiposAcoesReguaService,
    ValidarReguaServices,
} from "../../../../Services/Automacao/Regua/GestaoDeRegua/GestaoDeReguaServices";
import { Controller } from "../../../Controller";

export async function ValidarReguaController(IdRegua: number) {
    return Controller(ValidarReguaServices(IdRegua));
}

export async function DesvalidarReguaController(IdRegua: number) {
    return Controller(DesvalidarReguaServices(IdRegua));
}

export async function ListarReguaController() {
    return Controller(ListarReguaService());
}

export async function ListarServicosSMSController() {
    return Controller(ListarServicosSMSService());
}

export async function GetReguaController(idCasoCobrancaRegua: number) {
    return Controller(GetReguaService(idCasoCobrancaRegua));
}

export async function AtualizarReguaController(requestBody: IRegua) {
    return Controller(AtualizarReguaServices(requestBody));
}

export async function CadastrarReguaController(requestBody: IRegua) {
    return Controller(CadastrarReguaServices(requestBody));
}

export async function DeletarReguaController(idCasoCobrancaRegua: number) {
    return Controller(DeletarReguaServices(idCasoCobrancaRegua));
}

export async function ListarReguaEtapaController(idCasoCobrancaRegua: number) {
    return Controller(ListarReguaEtapaService(idCasoCobrancaRegua));
}

export async function GetReguaEtapaController(idEtapaRegua: number) {
    return Controller(GetReguaEtapaService(idEtapaRegua));
}

export async function CadastrarEtapaReguaController(requestBody: IReguaEtapa) {
    return Controller(CadastrarEtapaReguaService(requestBody));
}

export async function ListarAcoesReguaPorEtapaController(IdEtapaRegua: number) {
    return Controller(ListarAcoesReguaPorEtapaService(IdEtapaRegua));
}

export async function GetAcaoReguaController(IdAcaoEtapaRegua: number) {
    return Controller(GetAcaoReguaService(IdAcaoEtapaRegua));
}

export async function ListarTiposAcoesReguaController() {
    return Controller(ListarTiposAcoesReguaService());
}

//Filtro Ação Etapa
export async function ListarFiltrosAcaoEtapaController(
    IdAcaoEtapaRegua: number
) {
    return Controller(ListarFiltrosAcaoEtapaService(IdAcaoEtapaRegua));
}

export async function DeletarFiltroAcaoEtapaController(
    IdFiltroAcaoEtapaRegua: number
) {
    return Controller(DeletearFiltroAcaoEtapaService(IdFiltroAcaoEtapaRegua));
}

export async function EditarFiltroAcaoEtapaController(
    requestBody: IReguaEtapaAcaoFiltro
) {
    return Controller(EditarFiltroAcaoEtapaService(requestBody));
}

export async function CadastrarFiltroAcaoEtapaController(
    requestBody: IReguaEtapaAcaoFiltro
) {
    return Controller(CadastrarFiltroAcaoEtapaService(requestBody));
}

//Tipo Filtro Ação Etapa
export async function ListarTipoFiltroAcaoEtapaController() {
    return Controller(ListarTipoFiltroAcaoEtapaService());
}

//ordenação da etapa
export async function ListarOrdenacaoEtapaController(idEtapaRegua: number) {
    return Controller(ListarOrdenacaoEtapaService(idEtapaRegua));
}

export async function CadastrarOrdenacaoEtapaController(
    requestBody: IOrdenacaoReguaEtapa
) {
    return Controller(CadastrarOrdenacaoEtapaServices(requestBody));
}

export async function DeletarOrdenacaoEtapaController(idEtapaRegua: number) {
    return Controller(DeletarOrdenacaoEtapaServices(idEtapaRegua));
}

//Listar DADOS ações da etapa
export async function ListarDadosAcoesEtapaController(
    idReguaEtapaAcao: number,
    dsTipoAcao: string
) {
    return Controller(
        ListarDadosAcoesEtapaServices(idReguaEtapaAcao, dsTipoAcao)
    );
}

export async function ListarDadosAcoesEtapaBaixarExcelController(
    idReguaEtapaAcao: number,
    dsTipoAcao: string,
    flExcel?: boolean
) {
    return Controller(
        ListarDadosAcoesEtapaBaixarExcelService<Blob>(
            idReguaEtapaAcao,
            dsTipoAcao,
            flExcel
        )
    );
}

export async function AtualizarEtapaReguaController(requestBody: IReguaEtapa) {
    return Controller(AtualizarEtapaReguaService(requestBody));
}

export async function DeletarAcaoReguaContoller(IdAcaoEtapaRegua: number) {
    return Controller(DeletarAcaoReguaService(IdAcaoEtapaRegua));
}

export async function DeletarEtapaReguaController(idEtapaRegua: number) {
    return Controller(DeletarEtapaReguaService(idEtapaRegua));
}

//EXECUTAR REGUA
export async function ExecutarReguaController(
    requestBody: Array<IDadosReguaEtapa>,
    idReguaEtapaAcao: number
) {
    return Controller(ExecutarReguaServices(requestBody, idReguaEtapaAcao));
}

//AGENDAMENTO
export async function GetAgendaAcaoEtapaReguaController(
    idReguaEtapaAcao: number
) {
    return Controller(GetAgendaAcaoEtapaReguaServices(idReguaEtapaAcao));
}

export async function CadatrarAgendaAcaoEtapaReguaController(
    requestBody: IEtapaAcaoAgendamento
) {
    return Controller(CadatrarAgendaAcaoEtapaReguaServices(requestBody));
}

export async function DeletarAgendaAcaoEtapaReguaController(
    idReguaEtapaAcaoAgenda: number
) {
    return Controller(
        DeletarAgendaAcaoEtapaReguaServices(idReguaEtapaAcaoAgenda)
    );
}

export async function CadastrarAcaoEtapaController(
    requestBody: ICadastrarAcaoEtapaBody
) {
    return Controller(CadastrarAcaoEtapaService(requestBody));
}

export async function EditarAcaoEtapaController(
    requestBody: ICadastrarAcaoEtapaBody
) {
    return Controller(EditarAcaoEtapaService(requestBody));
}
